import { cn } from '@/lib/utils';

import { toolLabel } from '../knownTools';

/**
 * "via Claude Code" after a person's name, where the row came through their
 * AI tool (spec 246, from service 203's `via`). Nothing where it did not.
 *
 * Muted and without the tool's mark: it says how the work was done, beside who
 * did it, and must not outweigh the person. No separator: "Alice via Claude
 * Code" reads as the builder's "saved by Alice via Claude Code" does, and still
 * reads when a narrow line wraps it under the name. The name is the tool's own
 * claim and decides nothing, so everyone who sees the row sees it.
 */
export function ViaTool({
  via,
  className,
}: {
  via: string | null | undefined;
  className?: string;
}) {
  if (!via) return null;
  return (
    <span
      className={cn(
        'text-muted-foreground min-w-0 font-normal break-words',
        className,
      )}
      // A known tool says what it reported, as the AI tools page does; an
      // unknown one is whole on hover.
      title={via}
    >
      via {toolLabel(via)}
    </span>
  );
}
